import React from 'react';
import AbstractComponent from '../../AbstractComponent'; 

import Config from '../../../Config';

import './TopNav.css';

class TopNav extends AbstractComponent {  
    constructor(props) {
        super(props);

        this.state = {                        
            toggle: false
        }
    }    

    route(item) {
        if(this.props.usuario.empresa.id === 0) {
            alert('Selecione uma empresa');

            return ;
        }

        this.props.route(item);
    }

    onClick() {
        var el = document.getElementById("body");

        if(this.state.toggle) {
            el.classList.remove("sb-sidenav-toggled");
            this.setState({toggle: false});

            return;
        }

        el.classList.add("sb-sidenav-toggled");
        this.setState({toggle: true});
    }

    showMenu() {
        if(this.props.preload) {
            return ;
        }

        let menus = [];                    
        
        // if(this.props.usuario.avance === 1)             
        //     menus.push(this.addMenu('fa fa-cog', 'Tema', getAppDir() + 'tema'));                

        // menus.push(this.addMenu('fa fa-cog', 'Configuração', getAppDir() + 'settings'));                        

        return (        
            menus.map((item, i ) => {
                return(
                    <a 
                        className="dropdown-item" 
                        onClick={() => this.route(item)}
                        key={i}
                    >
                        <span className="btn-navigation__icon">                                            
                            <i className={item.icone} aria-hidden="true" />                                            
                        </span>
                        
                        <span className="btn-navigation__label">
                            {item.nome}
                        </span>                                                                            
                    </a>                                    
                )
            })
        );
    }    
    
    render() {
        return (
            <nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark">
                <a className="navbar-brand text-center" onClick={() => this.homePage2()}>                    
                    APPShop - Admin
                </a>                            

                <button className="btn btn-link btn-sm order-1 order-lg-0" id="sidebarToggle" onClick={() => this.onClick()}>
                    <i className="fas fa-bars">
                    </i>
                </button>                            

                <div className="d-none d-md-inline-block form-inline ml-auto mr-0 mr-md-3 my-2 my-md-0">  
                    
                </div>
                                
                <ul className="navbar-nav ml-auto ml-md-0">
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i className="fas fa-user fa-fw">
                            </i>
                        </a>

                        <div className="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
                            <div className="user-menu-items__name">
                                Olá, {this.props.usuario.nome}
                            </div> 

                            {this.showMenu()} 

                            <a 
                                className="dropdown-item" 
                                onClick={() => this.logout()}>
                                <span className="btn-navigation__icon">                                                                        
                                    <i className="fas fa-sign-out-alt"/>
                                </span>
                                
                                <span className="btn-navigation__label">
                                    Sair
                                </span>
                            </a>

                            <div
                                style={{
                                    fontSize: '11px',
                                    backgroundColor: '#F2F2F2',
                                    padding: '20px 30px',
                                    bottom: '0px',
                                    marginTop: '10px'
                                }}
                            >
                                Desenvolvido por
                                <br />
                                Avance Sistemas e Consultoria LTDA
                                <br />
                                CNPJ: 10.276.888/0001-43
                                <br />
                                37701-024 - Rua Piauí, 178
                                <br />
                                Centro - Poços de Caldas-MG
                                <br/>
                                <br/>
                                AppShop - Admin - versão {Config.versao}
                            </div>
                        </div>                                                    
                    </li>
                </ul>
            </nav>
        )
    }
}

export default TopNav;